"use strict"

let ComboBox;

export class DnD {
    
    static init(cb) {
        ComboBox=cb;

        window.addEventListener('dragstart', DnD.start, true);
        window.addEventListener('dragend', DnD.end, true);
        window.addEventListener('dragover', DnD.over, true);

    }
    
    static start(event) {
        if ((event.target instanceof HTMLElement)&&event.target.matches('.new-combobox .multioption')) {
            DnD.target=event.target;
            DnD.target.classList.add('in-drag');
            DnD.parent=event.target.parentNode;
        }
    }
    
    static over (event) {
        if (event.target.matches('.new-combobox .multioption')&&DnD.target&&DnD.parent) {
            let parent=event.target.parentNode;
            let combo=parent;
            while (!combo.matches('.new-combobox')) {combo=combo.parentNode;}
            let input=combo.previousElementSibling;
            
            if ((parent==DnD.parent)&&(event.target!=DnD.target)&&input&&input.matches('select')&&input.multiple) {

                let all=parent.querySelectorAll('.multioption');
                let scI=-1, tgI=-1;

                for (let i=0, l=all.length; i<l; i++) {
                    if (all[i]==event.target) {tgI=i} 
                    if (all[i]==DnD.target) {scI=i} 
                }

                let opts=input.querySelectorAll('option');
                let oscI=-1, otgI=-1;

                for (let i=0, l=opts.length; i<l; i++) {
                    if (opts[i].value==event.target.dataset.value) {otgI=i} 
                    if (opts[i].value==DnD.target.dataset.value) {oscI=i} 
                }

                if ((~scI)&&(~tgI)&&(~oscI)&&(~otgI)&&(oscI!=otgI)) {
                    let before=tgI<scI;
                    if (before) { event.target.parentNode.insertBefore(all[scI], all[tgI]); }
                    else { 
                        parent.insertBefore(all[scI], all[tgI].nextSibling);
                    }                    

                    before=otgI<oscI;
                    if (before) { input.insertBefore(opts[oscI], opts[otgI]); }
                    else { 
                        input.insertBefore(opts[oscI], opts[otgI].nextSibling);
                    }   
                    
                    event.preventDefault();
                }

            }
        }
    }
    
    static end (event) {
        if (DnD.target) {DnD.target.classList.remove('in-drag');}
        DnD.target=null;
        DnD.parent=null;
    }
    
}